import './sentry-instrument'
// Sentry initialization should be imported first!
import 'flatpickr/dist/themes/light.css'
import './styles/Datepicker.css'

import { ColorModeScript } from '@chakra-ui/react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import { setDefaultOptions } from 'date-fns'
import { cs } from 'date-fns/locale'
import moment from 'moment'
import '../../../node_modules/moment/dist/locale/cs'
import { App } from './App'
import { theme } from './theme'

setDefaultOptions({ locale: cs })
moment.locale('cs')

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')

const root = createRoot(container!)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      // Další globální nastavení
    },
  },
})

window.addEventListener('error', (event) => {
  if (
    event.message.includes(
      'ResizeObserver loop completed with undelivered notifications',
    )
  ) {
    console.warn('Ignored ResizeObserver loop error')
    event.stopImmediatePropagation()
    event.preventDefault()
  }
})

root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <ColorModeScript />
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />

    <App />

    <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
  </QueryClientProvider>,
  // </React.StrictMode>
)
